const LAW_COMPARISON_TOOL = {
    OPENED: {
        event: 'law-compare.opened',
        eventProperties: {
            description: 'User opened the Law Comparison Tool',
        },
    },
};

export default LAW_COMPARISON_TOOL;
